module.exports = new __parcel__URL__("gitlab.411423f1.svg").toString();